import axios from 'axios';
import DownloadFromStadiumEnum from '../model/downloadFromStadiumEnum';
import mapDownloadFromStadiumEnum from '../function/mapDownloadFromStadiumEnum';

export function getFileName(headers): string {
  let fileName = '';
  const contentDisposition = headers?.['content-disposition'];
  if (contentDisposition) {
    const regexMatch = contentDisposition.match(/.*filename="(.*)"/);
    if (regexMatch && regexMatch.length > 1) {
      // eslint-disable-next-line prefer-destructuring
      fileName = decodeURI(regexMatch[1]);
    }
  }
  return fileName;
}

// eslint-disable-next-line import/prefer-default-export
export const downloadExportedFile = (
  requestUrl: string,
  notFoundErrorMessage: string,
  setDisabled: (disabled: boolean) => void,
  setOpen?: (opened: boolean) => void,
  accessToken?: string,
  organizationId?: string,
  fromStadium: DownloadFromStadiumEnum = undefined,
): Promise<string> => {
  setDisabled(true);
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };
  const urlWithParams = `${requestUrl}?fromStadium=${mapDownloadFromStadiumEnum(fromStadium)}`;
  return axios({
    url: fromStadium !== undefined
      ? `${process.env.REACT_APP_BACKEND_REST_API}${urlWithParams}`
      : `${process.env.REACT_APP_BACKEND_REST_API}${requestUrl}`,
    method: 'GET',
    responseType: 'blob',
    headers,
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      getFileName(response.headers),
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    setDisabled(false);
    if (setOpen) {
      setOpen(false);
    }
    return null;
  }).catch(error => {
    if (setOpen) {
      setOpen(false);
    }
    setDisabled(false);
    if (error.response.status === 404) {
      return notFoundErrorMessage;
    }
    if (error.response.status === 500) {
      return 'Z technických príčin nebolo možné vykonať požadovanú akciu. Skúste neskôr.';
    }
    if (error.response.status === 400) {
      return error.response.data.text().then((message: string) => {
        if (message.startsWith('There are no podporovatelia for pripomienka ')) {
          return 'Zvolená hromadná pripomienka nemá žiadnych podporovateľov.';
        }
        return null;
      });
    }
    return null;
  });
};
